import React, { Component } from 'react';
import { RollbackOutlined } from '@ant-design/icons';
import { Button, Divider } from 'antd';
import { FormattedMessage } from 'react-intl';

import './NoMatch.css';

class NoMatch extends Component {
  render() {

    const goBack = this.props.history.goBack;
    return (
      <div className="no-match">
        <h1>404</h1>
			<Divider><h2><FormattedMessage id="page-not-found" defaultMessage={`Page Not Found`} /></h2></Divider>
        
			<Button size="large" onClick={goBack}><RollbackOutlined style={{ fontSize: 18 }} color="green" /><FormattedMessage id="page-not-found.go-back" defaultMessage={`Go Back`} /></Button>
      </div>
    );
  }
}

export default NoMatch

